export const paypalCurrency = process.env.REACT_APP_BASE_PAYPAL_CURRENCY;
